<script setup>
import { ref, onMounted, computed } from 'vue';
import { retrieve_child } from '@/services/child';
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration';
import { get_subscription_duration } from '@/services/subscriptions';
import { subs_time, swalError } from '@/helper';
import { update_subscription } from '@/services/subscriptions';

dayjs.extend(duration);
const props = defineProps({
  child_id:{
    required: true
  }
})

const isLoading = ref(true)
const isEmpty = ref(true)
const child = ref({})
const currentSub = ref({})
let interval = null
const now = ref(dayjs(new Date()))
onMounted(async()=>{
  await get_child_subscription()
  set_current_subscription()
  if (currentSub.value){
    await get_sub_duration()
    await check_sub_status()
  }
  interval = setInterval(() => {
    now.value = dayjs(new Date());
  }, 30000);
  isLoading.value = false
})

async function check_sub_status(){
  let start_date = dayjs(currentSub.value.attributes.start_date)
  let end_date = start_date.add(currentSub.value.subscription.duration, 'day')
  let tempDiff = end_date.diff(now.value)
  if (tempDiff < 0){
    let response = await update_subscription(currentSub.value.id, 'expired')
    if (response.error){
      swalError(response.result, true)
      return
    }
  }
}

async function get_sub_duration(){
  if (!currentSub.value){
    return
  }
  let response = await get_subscription_duration(currentSub.value.subscription.id)
  if (response.error){
    swalError(response.result, true)
    return
  }
  currentSub.value.subscription.duration = response.result.data.data.attributes.value
}

const timeDiff = computed(()=>{
  let time = "-"
  if (!currentSub.value){
    return time
  }
  if (currentSub.value.attributes.start_date != null){
    time = subs_time(currentSub.value.attributes.start_date, currentSub.value.subscription.duration)
  }
  return time
})

function set_current_subscription(){
  let temp = []
  // error handling
  if (child.value.subscriptions){
    temp = child.value.subscriptions.filter(item => item.attributes.status == null || item.attributes.status == "active")
  }
  currentSub.value = temp[0]
}

async function get_child_subscription(){
  let response = await retrieve_child(props.child_id, '?subscription=true&subscription_data=true')
  if (response.error){
    swalError(response.result, true)
    return
  }
  if (response.result.data.included?.length != 0){
    child.value = parseSubscription(response.result.data)
    isEmpty.value = false
  }
}

function parseSubscription(result){
  let tempChild = result.data
  let child_subscriptions = result.included.filter(item => item.type == 'child_subscription')
  child_subscriptions.forEach(childSub => {
    childSub.subscription = result.included.filter(item=>item.type == 'subscription').find(sub => childSub.attributes.subscription_id == sub.id)
  });
  tempChild.subscriptions = child_subscriptions
  return tempChild
}

</script>

<template>
  <div v-if="!isLoading" class="text-center"> 
    <p>
      <b>Time Left : </b>
      {{ timeDiff }}
    </p>
  </div>
</template>
  